import { AbstractWebSocketService } from "../../interfaces/abstract-web-socket-service";
export class WebSocketService extends AbstractWebSocketService {
  constructor() {
    super();
  }
  createWebSocket(id, query, variables, onMessageHandler, onCloseHandler) {
    const backend = this.createWebSocketEndpoint();
    const webSocket = new WebSocket(backend);
    webSocket.onopen = () => {
      const payload = {
        id,
        type: "start",
        payload: {
          query,
          variables,
        },
      };
      webSocket.send(JSON.stringify(payload));
    };
    webSocket.onmessage = (event) => {
      const wsMessage = JSON.parse(event.data);
      onMessageHandler(wsMessage, event);
    };
    webSocket.onclose = (event) => {
      onCloseHandler(event);
    };
    return webSocket;
  }
}
